import OnlineLink from "@/components/OnlineLink";

export type SearchOrigin = "inbox" | "later" | "my_day" | "planned";

interface Props {
  from: SearchOrigin;
}

export default function SearchLink({ from }: Props) {
  return (
    <OnlineLink
      href={`/search?from=${from}`}
      aria-label="Поиск"
      title="Поиск"
      className="p-1 text-gray-400 hover:text-blue-500 dark:text-gray-500"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M11 19a8 8 0 110-16 8 8 0 010 16z" />
      </svg>
    </OnlineLink>
  );
}
